<template>

<main class="py-12 space-y-12">
        <SectionsSectionIntro
            :images="sectionIntro.images"
            :title="sectionIntro.title"
            :teaser="sectionIntro.teaser"
            :text="sectionIntro.text"
        />

        <section>
            <div class="container grid lg:grid-cols-3 gap-12">
                <div/>
                <CardDownload
                    v-for="(pdf, index) in pdfDownloads"
                    :key="index"
                    :pdf="pdf"
                />
                <div/>
            </div>
        </section>
    </main>
</template>

<script setup lang="ts">
definePageMeta({
    path: '/Service/Inklusion',
});

const header = useState<{ title: string; subTitle: string }>(
    'header',
);
header.value = {
  title: 'Eine Welt',
  subTitle: 'für Alle',
};

const sectionIntro = {
    images: ['BQ4C1710.jpg', 'Öhringen_Bild-%2873%29.jpg', 'BQ4C5188.jpg'],
    title: 'Gemeinsam spielen...',
    teaser: 'Für öffentliche Spielplätze in Deutschland ist im Rahmen der Inklusion das Behindertengleichstellungsgesetz sowie die Behindertenrecht Konvention der UN zu beachten.',
    text: '<p>Wir denken, dass Menschen mit besonderen Fähigkeiten neben der Barrierefreiheit weitere Anreize zur Sinnes- und Bewegungsförderung haben sollen.</p>'
        + '<p>Ein inklusiver Spielraum ist ein Ort zum miteinander spielen für alle. Menschen mit und ohne Behinderung, sollen beim Spielen Spaß haben, körperliche Geschicklichkeit und Bewegungsabläufe weiterentwickeln und unterschiedliche Zusammenhänge über sich und ihre Umwelt kennenlernen.</p>'
        + '<p>Nicht alle Personen können alle Spielangebote uneingeschränkt nutzen. Daher ist es wichtig, ein möglichst breites Spektrum anzubieten, um unterschiedliche Fähigkeiten und Fertigkeiten anzusprechen, zu fördern und weiterzuentwickeln. Nicht jeder kann alles, aber für jeden Nutzenden werden Angebote benötigt.</p>'
        + '<p>Dafür bieten Ihnen unsere Piktogramme unter den Artikeln und die Filtermöglichkeiten im Produktkatalog die Möglichkeit, unsere Spielgeräte nach unterschiedlichen Sinneserfahrungen auzuwählen.</p>',
};

const pdfDownloads = ref([{
    title: 'Inklusion',
    file: '/pdf/Inklusion.pdf',
    image: 'Inklusion.png',
    type: 'PDF',
    size: '2,78 MB',
}]);
</script>

<style scoped>

</style>
